export const machineriesReducer = (state = {loading:true,result:null,machineries:null,machinery:null} , action) => {
    switch (action.type) {
        case 'MACHINERY_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                result: action.payload
            }
        case 'MACHINERIES_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                machineries: action.payload
            }
        case 'MACHINERY_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                machinery: action.payload
            }
        case 'MACHINERY_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                machineries: state.machineries.filter(machinery => machinery._id !== action.payload.idMachinery)
            }
        case 'MACHINERY_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'MACHINERY_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'MACHINERY_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'MACHINERY_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

